import script from "./everything-you-need-to-know-about-the-15-15-15-rule-in-mutual-funds.vue?vue&type=script&setup=true&lang=js"
export * from "./everything-you-need-to-know-about-the-15-15-15-rule-in-mutual-funds.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__